var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame178(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.7165 21.8598C43.7165 32.8999 35.5329 42.0271 24.9016 43.5082C23.9076 43.646 22.8906 43.718 21.8582 43.718C20.6666 43.718 19.4964 43.6231 18.3569 43.4393C7.94929 41.7636 0 32.7391 0 21.8598C0 9.78727 9.78727 0 21.8598 0C33.9323 0 43.7195 9.78727 43.7195 21.8598H43.7165Z",
    fill: "#3D3D3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9023 17.5527V22.3146H30.7931L29.8603 28.7292H24.9023V43.5081C23.9083 43.646 22.8913 43.7179 21.8589 43.7179C20.6673 43.7179 19.4971 43.623 18.3576 43.4392V28.7292H12.9248V22.3146H18.3576V16.4882C18.3576 12.8735 21.2876 9.94189 24.9039 9.94189V9.94496C24.9146 9.94496 24.9238 9.94189 24.9345 9.94189H30.7946V15.4896H26.9655C25.8275 15.4896 24.9039 16.4131 24.9039 17.5512L24.9023 17.5527Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame178);
export default __webpack_public_path__ + "static/media/Frame 178.bcd51604d38f8207c4a92bdaf648efef.svg";
export { ForwardRef as ReactComponent };